import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card, CardImg, CardText, CardBody, CardTitle, Container, Row, Col
} from 'reactstrap';

import distribution from './assets/distribution.png';
import data_overview from './assets/data_overview.png';
import time_series from './assets/time_series.png';
import regression from './assets/regression.png';

const Home = (props) => {
  return (
    <Container fluid={true} style={{padding: '0 5% 0 5%'}}>
      <h2>Anthrax Analysis and Visualization in Gannan Prefecture</h2>
      <Row>
        <Col>
          <div class="shadow-sm">
            <Card>
              <CardBody>
                <CardTitle tag="h5">Introduction</CardTitle>
                <CardText>
                  Anthrax is a infectious disease in Gannan Tibetan Autonomous Prefecture, Gansu Province, China.
                  This website is the analysis and visualization of anthrax cases in Gannan between 2005 and 2019.
                  In addition, this website contains regression models to investigate the association between meteorological factors and anthrax incidence.
                </CardText>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
      <Row xs="3" style={{ marginTop: '2rem' }}>
        <Col>
          <div class="shadow-sm">
            <Card>
              <CardBody>
                <CardTitle tag="h5">Data Overview</CardTitle>
                <CardText>Simple visualization of  anthrax cases in Gannan Prefecture.</CardText>
                <Link to="/overview/summary" class="card-link"> Data Statistics</Link>
                <br />
                <Link to="/overview/SpatialDistribution" class="card-link">Spatial Distribution</Link>
                <br />
                <Link to="/overview/TimeDistribution" class="card-link">Time Distribution</Link>
                <br />
                <br />
                <CardImg style={{marginTop: '1rem'}} bottom src={distribution} alt="data overview image" />
              </CardBody>
            </Card>
          </div>
        </Col>
        <Col>
          <div class="shadow-sm">
            <Card>
              <CardBody>
                <CardTitle tag="h5">Time Series Analysis</CardTitle>
                <CardText>Time series analysis of monthly new cases.</CardText>
                <Link to="/ts/decomposition" class="card-link">Time Series Decomposition</Link>
                <br />
                <Link to="/ts/forecast" class="card-link">Holt-Winters Forecast</Link>
                <br />
                <Link to="/ts/granger" class="card-link">Granger Casuality Test</Link>
                <CardImg style={{marginTop: '1rem'}} bottom src={time_series} alt="time series analysis image" />
              </CardBody>
            </Card>
          </div>
        </Col>
        <Col>
          <div class="shadow-sm">
            <Card>
              <CardBody>
                <CardTitle tag="h5">Regression Analysis</CardTitle>
                <CardText>Regression analysis for correlation between anthrax cases and meteorological factors.</CardText>
                <Link to="/regression/HI-calculator" class="card-link">Heat Index Calculator</Link>
                <br />
                <Link to="/regression/models" class="card-link">Regression Models</Link>
                <br />
                <br />
                <CardImg style={{marginTop: '1rem'}} bottom src={regression} alt="regression analysis image" />
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

              export default Home;

